<template>
  <el-main class="page-content-margin-unset">
    <div class="table-top dk-li">
      <el-input
        placeholder="请输入用户名称/订单号进行搜索"
        v-model="body.keyword"
        clearable
        class="input-with-select dk_input"/>
      <div>
        <span style="line-height: 40px;margin-right:10px">提交时间</span>
        <el-date-picker
          v-model="times"
          clearable
          value-format="yyyy-MM-dd"
          @change="onTimeChange()"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"/>
      </div>
      <el-button
        type="primary"
        @click="search()">
        搜索
      </el-button>
      <el-button @click="event().clearKeyword()">重置</el-button>
    </div>
    <el-tabs
      v-model="activeName"
      @tab-click="handleClick">
      <el-tab-pane
        label="全部"
        name="all">
        <!-- 表格 -->
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nickname"
            label="用户名称"/>
          <el-table-column
            prop="order_id"
            label="订单编号"/>
          <el-table-column
            prop="mobile"
            label="手机号"/>
          <el-table-column
            prop="paid_money"
            label="实际支付金额"/>
          <el-table-column
            prop="status"
            label="售后状态"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.status === '处理中'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toSetComplete(scope.row)">
                完成关闭
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="处理中"
        name="pending">
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nickname"
            label="用户名称"/>
          <el-table-column
            prop="order_id"
            label="订单编号"/>
          <el-table-column
            prop="mobile"
            label="手机号"/>
          <el-table-column
            prop="paid_money"
            label="实际支付金额"/>
          <el-table-column
            prop="status"
            label="售后状态"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
              <el-button
                v-if="scope.row.status === '处理中'"
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toSetComplete(scope.row.uuid)">
                完成关闭
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane
        label="已关闭"
        name="passed">
        <el-table
          border
          :data="tableData">
          <el-table-column
            prop="nickname"
            label="用户名称"/>
          <el-table-column
            prop="order_id"
            label="订单编号"/>
          <el-table-column
            prop="mobile"
            label="手机号"/>
          <el-table-column
            prop="paid_money"
            label="实际支付金额"/>
          <el-table-column
            prop="status"
            label="售后状态"/>
          <el-table-column
            prop="create_time"
            label="提交时间"/>
          <el-table-column
            fixed="right"
            label="操作"
            width="330">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                class="mini-el-button"
                @click="event().toDetailClick(scope.row.uuid)">
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>

    <!-- 分页组件 -->
    <div class="pagination-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page.sync="body.page_index"
        :page-size="body.page_size"
        layout="prev, pager, next"
        :total="total"/>
    </div>

    <!-- 完成关闭 -->
    <el-dialog
      width="340px"
      title="提示，请输入关闭理由？"
      :visible.sync="setCompleteDialog">
      <el-form
        :model="setCompleteBody"
        ref="ruleForm3"
        class="demo-ruleForm">
          <el-input
            type="textarea"
            class="dk-input"
            v-model="setCompleteBody.content"/>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="setCompleteDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureSetCompleteClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>

<script>
import { getAfterSaleList, setComplete } from '../../api/after-sale'
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { setId } from '../../jslib/set-id'
import {addSupplier} from "../../api/user";

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      body: {
        keyword: '',
        status: '',
        page_index: 1,
        page_size: 20,
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      activeName: 'all',
      setCompleteDialog: false,
      setCompleteBody: {},
    };
  },

  components: {
  },
  created() {
    this.network().getAfterSaleList()
  },
  methods: {
    search() {
      this.network().getAfterSaleList()
    },
    handleCurrentChange () {
      this.network().getAfterSaleList()
    },
    handleClick(tab, event) {
      if (tab.name === 'pending') {
        this.body.status = 0
      } else if (tab.name === 'passed') {
        this.body.status = 1
      } else {
        this.body.status = ''
      }
      this.network().getAfterSaleList()
    },
    event() {
      return {
        clearKeyword: () => {
          this.body.keyword = ''
          this.times = []
        },
        toDetailClick: (uuid) => {
          this.$router.push({ path: 'detail', query: { uuid } })
        },
        onSureSetCompleteClick: () => {
          this.network().setComplete()
        },
        toSetComplete: (row) => {
          this.setCompleteBody.uuid = row.uuid
          this.setCompleteDialog = true
        },
      }
    },
    network() {
      return {
        getAfterSaleList: async () => {
          const { status, data } = await getAfterSaleList(this.body)
          if (status !== 200) return
          this.tableData = setId(data.data, this.body.page_index, this.body.page_size)
          this.tableData = data.data
          this.total = data.total
        },
        setComplete: async () => {
          const { status } = await setComplete(this.setCompleteBody)
          if (status !== 200) return
          this.network().getAfterSaleList()
          this.setCompleteDialog = false
          this.$notify({
            title: '关闭成功',
            message: '关闭成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/mixins.scss';
.table-top{
  @include dk-table-top;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/after-sale/list.vue